import './SuperAdminAssets.scss';
import React, {useContext, useState} from 'react';
import {I18nReactContext} from "../../../contexts/I18nContext";
import {SuperAdminAssetsTable} from "./SuperAdminAssetsTable/SuperAdminAssetsTable";
import {GridReactContextProvider} from "../../../Utils/DataGridWrapper/GridContext";

export const SuperAdminAssets = () => {
    const {i18n} = useContext(I18nReactContext);

    return (
        <div className="SuperAdminAssets">
            <div className="pageTitle">
                {i18n.translate('superAdmin.assets.title')}
            </div>
            <div className="superAdminAssetsTableWrapper">
                <GridReactContextProvider>
                    <SuperAdminAssetsTable />
                </GridReactContextProvider>
            </div>
        </div>
    );
};
